import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "reactstrap";
import { IoCloseSharp } from "react-icons/io5";
import CustomSelect from "../../../Components/CustomSelect/CustomSelect";
import { FaSearch } from "react-icons/fa";
import questionSvg from "../../../Assets/icons/question.svg";
const HomeworkForm1 = ({
  texteditorRef,
  payload,
  modules,
  formats,
  handlePaste,
  handleChange,
  question,
  error,
  isError,
  selectedType,
  selectedSubject,
  formData,
  rest,
  pathname,
}) => {
  const questionRef = useRef(null);
  useEffect(() => {
    questionRef.current.addEventListener("dragover", handleQuestionDragOver);
    questionRef.current.addEventListener("drop", handleQuestionDrop);

    return () => {
      questionRef.current?.removeEventListener(
        "dragover",
        handleQuestionDragOver,
      );
      questionRef.current?.removeEventListener("drop", handleQuestionDrop);
    };
  }, []);

  const handleQuestionDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleQuestionDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { files } = e.dataTransfer;

    if (files && files.length) {
      const event = {
        target: {
          files: files,
          name: "questionPDF",
        },
      };
      handleChange(event);
    }
  };

  useEffect(() => {
    if (!pathname || !formData?.subcategory) return;

    const matchedCategory = formData.subcategory.find(
      (item) => item.url === pathname,
    );

    if (matchedCategory) {
      handleChange({
        target: {
          name: "questionType",
          value: matchedCategory._id,
        },
      });
    }
  }, [pathname, formData]);
  const categoryOptions = formData?.subcategory?.map((data) => ({
    value: data._id,
    label: data.name,
    image: data.image,
    url: data.url,
  }));

  const subjectOptions = formData?.subject?.map((data) => ({
    value: data._id,
    label: data.subSubjectName,
    image: data.image,
    parent: data?.subjectId?.questionSubject,
  }));
  return (
    <Container className="mb-4">
      <h1 className="step-header text-center mb-3">Upload Question</h1>
      <Row className="g-4 mt-3">
        <Col md={6}>
          <CustomSelect
            name="questionType"
            options={categoryOptions}
            value={payload?.questionType}
            placeholder="Select your question type"
            handleChange={handleChange}
            error={error?.questionType}
            icon={FaSearch}
          />
        </Col>

        <Col md={6}>
          <CustomSelect
            name="subject"
            options={subjectOptions}
            value={payload?.subject}
            placeholder="Select your subject"
            handleChange={handleChange}
            error={error?.subject}
            icon={FaSearch}
          />
        </Col>

        <Col md={6}>
          <div className="place-your-writing-container">
            <label
              htmlFor="uploadQuestionPDF"
              className="place-your-writing-label"
            >
              <div className="upload-file-container" ref={questionRef}>
                <span>
                  {" "}
                  Drop your File or{" "}
                  <span className="text-primary">Browse</span>{" "}
                </span>
              </div>
              <input
                type="file"
                hidden
                multiple
                id="uploadQuestionPDF"
                name="questionPDF"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.rtf,.html,.htm,.xml,.json,.js,.css,.java,.py,.cpp,.cs,.rb,.php,.swift,.pl,.sh,.bat,.ps1,.vbs,.asm,.c,.h,.cpp,.hpp,.cs,.java,.jar,.py,.rb,.pl,.php,.shtml,.asp,.aspx,.jsp,.aspx,.jsp,.cfm,.actionscript,.sgf,.wasm,.unity,.gmx,.gmz,.love,.ase,.aseprite,.atlas,.png,.jpg,.jpeg"
                onChange={handleChange}
              />
            </label>
          </div>

          <div className="w-auto path-contents">
            {payload?.questionPDF &&
              payload?.questionPDF?.map((file, index) => (
                <div className="row reference-section mt-3 rounded ">
                  <div>
                    <div className="text-primary fs-5 border auto-width mx-2">
                      <span className="mx-2">{file.name}</span>
                      <button
                        className="btnClose ms-1 "
                        onClick={() =>
                          rest?.handleRemoveFile(index, "questionPDF")
                        }
                        style={{ zIndex: 1 }}
                        type="button"
                      >
                        <IoCloseSharp className="text-center mb-1" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </Col>

        <Col md={6}>
          <div className="place-your-writing-container">
            <textarea
              name="question"
              id="typeYourQuestion"
              style={{ borderRadius: "inherit" }}
              placeholder="Type your questions here"
              value={payload?.question}
              onChange={handleChange}
            ></textarea>
          </div>
          {isError && error.question && (
            <span
              className="text-danger mt-1 d-block"
              style={{ fontSize: "12px" }}
            >
              {error.question}
            </span>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default HomeworkForm1;
